import {
  DEFAULT_ANNIVERSARY_DEVICE_INFO,
  DEFAULT_HARDWARE_RECALL_INFO,
  TIME_FORMAT,
} from '@/pages/acts/ninthAnniversary/config';
import { NAS_PLANET_ACT, PC_XL_ACT } from '@/pages/acts/xlvip/constants';
import {
  bigturnLottery,
  checkAnniversaryRewardAccount,
  getActivityCalendar,
  getActivityRankData,
  getActivityUserInfo,
  getAnniversaryDeviceCalendar,
  getAnniversaryDeviceDetail,
  getAnniversaryDeviceList,
  getAnniversaryDeviceRewardRecord,
  getInviteLotteryInfo,
  getInviteLotteryLeftNum,
  getInviteLotteryReward,
  getPopupAdsConfig,
  getProductModalInfo,
  getRecallActSignUpInfo,
  getSignUpDetails,
  getXunLeiActDeviceCalendar,
  getXunLeiActDeviceDetail,
  getXunLeiRewardRecord,
  getXunLeiVipActSummary,
  getYundouLotteryDetails,
  inviteLottery,
  markAuthPop,
  querySplitCashActData,
  queryTaskInfo,
  queryUserBelongGroup,
  receiveXunLeiReward,
  setAnniversaryRewardAccount,
  setBandWdith,
  shareInviteTaskSuccess,
  signUpRecallAct,
  validateDeviceStatus,
  recallDeviceActData,
  hardwareRecallActRewardData,
} from '@/services/acts';
import moment from 'moment';
import { getInviteLink, getInviteSchedule } from '../pages/invite/services';

export default {
  namespace: 'acts',

  state: {
    productModalInfo: {},
    popupConfig: {},
    splitCashData: {
      invite_rank_list: [],
      update_time: '--',
      own_rank: 0,
      cash_reward: '--',
    },
    taskInfoMap: new Map(),
    onlineDevices: [],
    addDeviceRankList: [],
    addDeviceRankDate: '',
    addDeviceUserInfo: {},
    addDeviceRewardList: [],
    // 9周年活动
    anniversaryDeviceList: [],
    anniversaryDeviceDetail: DEFAULT_ANNIVERSARY_DEVICE_INFO,
    // 日历数据map
    anniversaryDeviceCalenderMap: new Map(),
    // 领取记录
    anniversaryRewardRecordInfo: {},
    // 迅雷会员活动
    xlVipActSummary: [],
    // PCXL设备列表
    pcxlDeviceList: [],
    xlVipActRewardRecord: {},
    xlVipActDeviceDetail: {
      rdl: [],
      udl: [],
      edl: [],
    },
    xlVipActDeviceCalenderMap: new Map(),
    xlVipActDeviceReward: [],
    shareInfo: {},
    inviteLotteryReward: [],
    inviteLotteryLeftNum: 0,
    inviteLotteryInfo: {
      bindCnt: 0, //绑定次数
      registerCnt: 0, //注册次数
      shareCnt: 0, //分享次数
      totalCnt: 0, //总次数
    },
    // 小盒子召回活动
    recallActSignUpStatus: false,
    // 硬件召回活动
    hardwareRecallDetail: DEFAULT_HARDWARE_RECALL_INFO,
  },

  effects: {
    *markAuthPop({ payload, callback }, { call }) {
      const res = yield call(markAuthPop, payload);
      if (res && res.iRet === 0) {
        if (callback) callback();
      }
    },
    *getProductModalInfo({ payload, callback }, { call, put }) {
      const res = yield call(getProductModalInfo, payload);
      if (res && res.iRet === 0) {
        if (callback) callback();
        yield put({
          type: 'save',
          payload: { productModalInfo: res.data },
        });
      }
    },
    *getPopupAdsConfig({ payload, successCallback, failCallback }, { call, put }) {
      const res = yield call(getPopupAdsConfig, payload);
      if (res?.iRet === 0 && res.data?.popup_info) {
        yield put({
          type: 'save',
          payload: { popupConfig: res.data.popup_info },
        });
        successCallback && successCallback(res.data?.popup_info);
      } else {
        failCallback && failCallback();
      }
    },
    *querySplitCashActData({ payload, callback }, { call, put }) {
      const res = yield call(querySplitCashActData, payload);
      if (res?.iRet === 0) {
        if (callback) callback();
        yield put({
          type: 'save',
          payload: { splitCashData: res.data || {} },
        });
      }
    },
    *queryUserBelongGroup({ payload, callback }, { call }) {
      const res = yield call(queryUserBelongGroup, payload);
      if (res?.iRet === 0) {
        callback && callback(res.data);
      }
    },
    *queryTaskInfo({ payload, callback }, { call, put }) {
      const res = yield call(queryTaskInfo, payload);
      if (res?.iRet === 0) {
        const { taskList = [], invitationType } = res.data || {};
        const taskInfoMap = new Map(taskList.map(item => [item.taskType, item]) || []);
        yield put({
          type: 'save',
          payload: { taskInfoMap },
        });
        callback && callback(taskInfoMap, invitationType);
      }
    },
    *queryOnlineDevices({ payload, callback }, { call, put }) {
      const res = yield call(getInviteSchedule, payload);
      if (res?.iRet === 0) {
        const onlineDevices = res.data?.deviceList || [];
        yield put({
          type: 'save',
          payload: {
            onlineDevices,
          },
        });
        callback && callback(onlineDevices);
      }
    },
    *setBandWdith({ payload, callback }, { call }) {
      const res = yield call(setBandWdith, payload);
      if (res?.iRet === 0) {
        callback && callback(res.data);
      }
    },
    *getSignUpDetails({ payload, callback }, { call }) {
      const res = yield call(getSignUpDetails, payload);
      if (res?.iRet === 0 && Object.keys(res.data).length > 0) {
        callback && callback(res.data);
      }
    },
    *getActivityRankData({ payload, callback }, { call, put }) {
      const res = yield call(getActivityRankData, payload);
      if (res?.iRet === 0) {
        callback && callback(res.data);
        yield put({
          type: 'save',
          payload: {
            addDeviceRankList: res.data?.rank_info || [],
            addDeviceRankDate: res.data?.data_time || '',
          },
        });
      }
    },
    *getActivityUserInfo({ payload, callback }, { call, put }) {
      const res = yield call(getActivityUserInfo, payload);
      if (res?.iRet === 0) {
        callback && callback(res.data);
        yield put({
          type: 'save',
          payload: { addDeviceUserInfo: res.data },
        });
      }
    },
    *getActivityCalendar({ payload, callback }, { call, put }) {
      const res = yield call(getActivityCalendar, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            addDeviceRewardList: res.data?.calender || [],
          },
        });
        if (callback) callback();
      }
    },

    *getYundouLotteryDetails({ payload, callback }, { call }) {
      const res = yield call(getYundouLotteryDetails, payload);
      // if (res?.iRet === 0) {
      callback && callback(res);
      // }
    },

    *bigturnLottery({ payload, successCallback, failCallback }, { call }) {
      const res = yield call(bigturnLottery, payload);
      if (res?.iRet === 0) {
        successCallback && successCallback(res.data);
      } else {
        failCallback && failCallback();
      }
    },
    *getAnniversaryDeviceList({ payload, callback }, { call, put }) {
      const res = yield call(getAnniversaryDeviceList, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            anniversaryDeviceList: res.data?.l || [],
          },
        });
        if (callback) callback();
      }
    },
    *getAnniversaryDeviceDetail({ payload, callback }, { call, put }) {
      const res = yield call(getAnniversaryDeviceDetail, payload);
      if (res?.iRet === 0 && res.data) {
        const { xm = '', nm = '', st, ...resetInfo } = res.data || {};
        yield put({
          type: 'save',
          payload: {
            anniversaryDeviceDetail: {
              ...resetInfo,
              st,
              xm: moment(xm).format(TIME_FORMAT),
              nm: moment(nm).format(TIME_FORMAT),
            },
          },
        });
        if (callback) callback(st);
      }
    },
    *getAnniversaryDeviceCalendar({ payload, callback }, { call, put }) {
      const res = yield call(getAnniversaryDeviceCalendar, payload);
      if (res?.iRet === 0 && res.data) {
        const { cd = [] } = res.data;
        const anniversaryDeviceCalenderMap = new Map(
          cd.map(item => {
            return [item.d, item];
          })
        );
        yield put({
          type: 'save',
          payload: {
            anniversaryDeviceCalenderMap,
          },
        });
        if (callback) callback();
      }
    },
    *getAnniversaryDeviceRewardRecord({ payload, callback }, { call, put }) {
      const res = yield call(getAnniversaryDeviceRewardRecord, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            anniversaryRewardRecordInfo: res.data,
          },
        });
        if (callback) callback();
      }
    },
    *setAnniversaryRewardAccount({ payload, callback }, { call }) {
      const res = yield call(setAnniversaryRewardAccount, payload);
      if (callback) callback(res);
    },
    *checkAnniversaryRewardAccount({ payload, callback }, { call }) {
      const res = yield call(checkAnniversaryRewardAccount, payload);
      if (res?.iRet === 0) {
        if (callback) callback();
      }
    },
    *getXunLeiVipActSummary({ payload, callback }, { call, put }) {
      const res = yield call(getXunLeiVipActSummary, payload);
      if (res?.iRet === 0 && res.data) {
        const { l: actList = [] } = res.data;
        const pcxlAct = actList.find(item => item.ai === PC_XL_ACT);
        const nasAct = actList.find(item => item.ai === NAS_PLANET_ACT);
        if (callback) callback(pcxlAct, nasAct);
        yield put({
          type: 'save',
          payload: {
            // 过滤掉没有设备的迅雷会员活动
            xlVipActSummary: actList.filter(item => item.dn > 0),
            pcxlDeviceList: pcxlAct?.dl || [],
            nasDeviceList: nasAct?.dl || [],
          },
        });
      }
    },
    *getXunLeiRewardRecord({ payload, callback }, { call, put }) {
      const res = yield call(getXunLeiRewardRecord, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            xlVipActRewardRecord: res.data,
          },
        });
        if (callback) callback(res.data);
      }
    },
    *receiveXunLeiReward({ payload, callback }, { call }) {
      const res = yield call(receiveXunLeiReward, payload);
      if (res?.iRet === 0) {
        if (callback) callback(res.data);
      }
    },
    *getXunLeiActDeviceDetail({ payload, callback }, { call, put }) {
      const res = yield call(getXunLeiActDeviceDetail, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            xlVipActDeviceDetail: res.data,
          },
        });
        if (callback) callback(res.data);
      }
    },
    *getXunLeiActDeviceCalendar({ payload, callback }, { call, put }) {
      const res = yield call(getXunLeiActDeviceCalendar, payload);
      if (res?.iRet === 0 && res.data) {
        const { cd = [] } = res.data;
        const xlVipActDeviceCalenderMap = new Map(
          cd.map(item => {
            return [item.d, item];
          })
        );
        yield put({
          type: 'save',
          payload: {
            xlVipActDeviceCalenderMap,
          },
        });
        if (callback) callback();
      } else {
        yield put({
          type: 'save',
          payload: {
            xlVipActDeviceCalenderMap: new Map(),
          },
        });
      }
    },
    *getXunLeiActDeviceReward({ payload, callback }, { call, put }) {
      const res = yield call(getXunLeiRewardRecord, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            xlVipActDeviceReward: res.data,
          },
        });
        if (callback) callback(res.data);
      } else {
        yield put({
          type: 'save',
          payload: {
            xlVipActDeviceReward: [],
          },
        });
      }
    },
    // 邀请好友抽奖活动
    *getInviteLink({ payload, callback }, { call, put }) {
      const res = yield call(getInviteLink, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            shareInfo: res.data,
          },
        });
        callback && callback(res.data);
      }
    },
    *getInviteLotteryLeftNum({ payload }, { call, put }) {
      const res = yield call(getInviteLotteryLeftNum, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            inviteLotteryLeftNum: res.data.cnt,
          },
        });
      }
    },
    *getInviteLotteryReward({ payload, callback }, { call, put }) {
      const res = yield call(getInviteLotteryReward, payload);
      if (res?.iRet === 0 && res.data) {
        yield put({
          type: 'save',
          payload: {
            inviteLotteryReward: res.data.list || [],
          },
        });
        callback && callback(res.data);
      }
    },
    // 邀请好友抽奖
    *inviteLottery({ payload, callback }, { call }) {
      const res = yield call(inviteLottery, payload);
      callback(res);
    },
    // 获取邀请好友抽奖信息
    *getInviteLotteryInfo({ payload, callback }, { call, put }) {
      const res = yield call(getInviteLotteryInfo, payload);
      if (res?.iRet === 0 && res.data) {
        const { registerCnt = 0, bindCnt = 0, shareCnt = 0 } = res.data;
        yield put({
          type: 'save',
          payload: {
            inviteLotteryInfo: {
              registerCnt,
              bindCnt,
              shareCnt,
              totalCnt: registerCnt + bindCnt + shareCnt,
            },
          },
        });
        callback && callback(res.data);
      }
    },
    *shareInviteTaskSuccess({ payload, callback }, { call }) {
      const res = yield call(shareInviteTaskSuccess, payload);
      if (res?.iRet === 0) {
        callback && callback(res.data);
      }
    },
    *getRecallActSignUpInfo({ payload, callback }, { call, put }) {
      const res = yield call(getRecallActSignUpInfo, payload);
      if (res?.iRet === 0) {
        const { has_sign_up = false } = res.data;
        yield put({
          type: 'save',
          payload: {
            recallActSignUpStatus: has_sign_up,
          },
        });
        callback && callback(res.data);
      }
    },
    *signUpRecallAct({ payload, callback }, { call, put }) {
      const res = yield call(signUpRecallAct, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            recallActSignUpStatus: true,
          },
        });
        callback && callback(res);
      }
    },
    *recallDeviceActData({ payload, callback, failCallback }, { call, put }) {
      const res = yield call(recallDeviceActData, payload);
      if (res?.iRet === 0) {
        callback && callback(res.data);
      }
    },

    *hardwareRecallActRewardData({ payload, callback, failCallback }, { call, put }) {
      const res = yield call(hardwareRecallActRewardData, payload);
      if (res?.iRet === 0) {
        yield put({
          type: 'save',
          payload: {
            hardwareRecallDetail: res.data,
          },
        });
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    saveApplyResultList(state, { payload }) {
      const { addDeviceRewardList: oldList } = state;
      const { addDeviceRewardList, page } = payload;
      const isFirstPage = page === 1;
      return {
        ...state,
        addDeviceRewardList: isFirstPage
          ? [...addDeviceRewardList]
          : [...oldList, ...addDeviceRewardList],
        // isResultListAll: addDeviceRewardList.length < PAGE_SIZE,
      };
    },
  },
};
